import { START_GET_TAGS } from '../types';
    
export const getTags = () => ({
    type: START_GET_TAGS
})